import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36e014d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-wrap-out" }
const _hoisted_2 = { class: "card-wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "card-type"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-text" }, null, -1))
const _hoisted_6 = ["src"]

import { computed, withDefaults } from 'vue'
import type { CardItemType } from '@/types/my-credentials'
import noActiveCard from '@/assets/my-credentails/credentails/no_active.png'
import {
  getBgBackgroundHandle,
  judgeIsNewUavOperatorCertificate,
  judgeCetifateIsDiaoyunOperater,
  judgeCetifateIsAgriculturalRobot,
  judgeCetifateIsAgriculturalUnmannedVehicle,
} from '@/compositions/my-crendentials/index'
import schoolCode from '@/assets/my-credentails/credentails/school_code.png'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  components: {},
  name: 'card-bg-item',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    cardItem: null,
    scale: { default: 1 },
    type: null,
    cardName: null
  },
  setup(__props: any) {

const props = __props as { cardItem: CardItemType, scale: number, type: string, cardName: string };



const isDiaoyunOperator = computed(() => {
  return judgeCetifateIsDiaoyunOperater(props.cardItem)
})

const isNewUavOperateItem = computed(() => {
  return judgeIsNewUavOperatorCertificate(props.cardItem)
})

// 农业机器人/无人车证件正面不展示 cardName
const isAgriculturalRobot = computed(() => {
  return (
    judgeCetifateIsAgriculturalRobot(props.cardItem) ||
    judgeCetifateIsAgriculturalUnmannedVehicle(props.cardItem)
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.type)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "card-item",
            style: _normalizeStyle({ transform: `scale(${__props.scale})` })
          }, [
            _createElementVNode("img", {
              width: "517",
              height: "331",
              src: _unref(getBgBackgroundHandle)(props.type)
            }, null, 8, _hoisted_3),
            (!_unref(isNewUavOperateItem))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!_unref(isAgriculturalRobot))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.cardName), 1))
                    : _createCommentVNode("", true),
                  _hoisted_5,
                  _createElementVNode("img", {
                    class: "shcool-code",
                    width: "68",
                    height: "68",
                    src: _unref(schoolCode)
                  }, null, 8, _hoisted_6)
                ], 64))
              : _createCommentVNode("", true)
          ], 4))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})